import { render, staticRenderFns } from "./PelletsChartTooltip.vue?vue&type=template&id=cfedcdc0&scoped=true"
import script from "./PelletsChartTooltip.vue?vue&type=script&lang=ts"
export * from "./PelletsChartTooltip.vue?vue&type=script&lang=ts"
import style0 from "./PelletsChartTooltip.vue?vue&type=style&index=0&id=cfedcdc0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfedcdc0",
  null
  
)

export default component.exports